
import { defineComponent, computed } from 'vue';

import icons from './icons';

export default defineComponent({
  name: 'Icon',
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    return {
      paths: computed(() =>
        Array.isArray(icons[props.type])
          ? icons[props.type]
          : [icons[props.type]]
      ),
    };
  },
});
